export const LANGUAGES = [
  { code: "en", label: "English", nativeLabel: "English" },
  { code: "te", label: "Telugu",  nativeLabel: "తెలుగు"  },
] as const;

export type LangCode = "en" | "te";
